import React from "react";
import {
  Box,
  Container,
  Grid,
  TextField,
  Button,
  IconButton,
} from "@mui/material";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const ContactSection = () => {
  return (
    <Box sx={{ backgroundColor: "#1e242c", py: 10 }}>
      <Container maxWidth="md">
        <Grid container spacing={2}>
          <Grid size={6}>
            <TextField
              placeholder="Name"
              fullWidth
              variant="outlined"
              InputProps={{ style: { color: "wheat" } }}
              sx={{
                "& fieldset": { borderColor: "wheat" },
                "& input::placeholder": { color: "wheat" },
              }}
            />
          </Grid>
          <Grid size={6}>
            <TextField
              placeholder="Email address"
              fullWidth
              variant="outlined"
              InputProps={{ style: { color: "wheat" } }}
              sx={{
                "& fieldset": { borderColor: "wheat" },
                "& input::placeholder": { color: "wheat" },
              }}
            />
          </Grid>

          <Grid size={12}>
            <TextField
              placeholder="Subject"
              fullWidth
              variant="outlined"
              InputProps={{ style: { color: "wheat" } }}
              sx={{
                "& fieldset": { borderColor: "wheat" },
                "& input::placeholder": { color: "wheat" },
              }}
            />
          </Grid>

          <Grid size={12}>
            <TextField
              placeholder="Message"
              fullWidth
              multiline
              rows={5}
              variant="outlined"
              InputProps={{ style: { color: "wheat" } }}
              sx={{
                "& fieldset": { borderColor: "wheat" },
                "& textarea::placeholder": { color: "wheat" },
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <Button
              variant="outlined"
              sx={{
                color: "wheat",
                borderColor: "wheat",
                fontWeight: "bold",
                "&:hover": {
                  backgroundColor: "wheat",
                  color: "#0e141e",
                },
              }}
            >
              SUBMIT
            </Button>
          </Grid>
        </Grid>

        {/* Footer - Logo and Socials */}
        <Box sx={{ textAlign: "center", mt: 10 }}>
          <img
            src="/S1.png"
            alt="Logo"
            style={{ height: 200, marginTop: 10 }}
          />

          <Box sx={{ mt: 2 }}>
            <a
              href="https://www.instagram.com/sruhad.inv"
              target="_blank"
              rel="noopener noreferrer"
            >
              <IconButton sx={{ color: "wheat", mx: 1 }}>
                <InstagramIcon sx={{ fontSize: 40 }} />
              </IconButton>
            </a>
            <a
              href="https://www.facebook.com/sruhad.inv/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <IconButton sx={{ color: "wheat", mx: 1 }}>
                <FacebookIcon sx={{ fontSize: 40 }} />
              </IconButton>
            </a>
            <a
              href="https://wa.me/+256705332050"
              target="_blank"
              rel="noopener noreferrer"
            >
              <IconButton sx={{ color: "wheat", mx: 1 }}>
                <WhatsAppIcon sx={{ fontSize: 40 }} />
              </IconButton>
            </a>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default ContactSection;
